import { rem } from 'design-system';
export const SELECTED_ITEM_HEIGHT = rem(76);
